import { t } from "@/i18n-js/instance";

import { LineItem } from "./LineItem";

interface TotalDueProps {
  totalDue?: string;
}

export const TotalDue = ({ totalDue }: TotalDueProps) => (
  <LineItem
    title={t("pricing_plans.change_plan.total_due")}
    amount={totalDue ?? ""}
    semibold
    amountWeight="semibold"
  />
);
